module.exports = __webpack_public_path__ + "img/Literatura II.4af07143.png";